module.exports = "<div id=\"pie-container\" class=\"example\">\n    <app-label [id]=\"labelId\" [message]=\"labelMessage\"></app-label>\n    <div id=\"{{pieId}}\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/src/app/pie/pie.component.html
// module id = ../../../../../src/app/pie/pie.component.html
// module chunks = 1